import { IconPaths, ModalSize } from '../../../../../_metronic/helpers'
import { Button, InfoAlert, TableCard, useModal } from '../../../../components'
import { usePermissoesFeriado } from '../core/usePermissoesFeriado'
import { FeriadoFormModal } from './components/FeriadoFormModal'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider, useQueryResponse } from './core/QueryResponseProvider'
import { FeriadosTable } from './table/FeriadosTable'

const FeriadosList = () => {
  const { showModal } = useModal()
  const { refetch } = useQueryResponse()
  // `Feriado:create` é só de SUPER_ADMIN/ADMIN: o médico e o EMPLOYEE leem a
  // lista, e para eles o botão só produziria 403.
  const { podeEscrever } = usePermissoesFeriado()

  const abrirCadastro = () =>
    showModal({
      title: 'Novo feriado',
      size: ModalSize.Large,
      content: <FeriadoFormModal onSuccess={refetch} />,
    })

  return (
    <>
      <InfoAlert variant='info' title='Feriados bloqueiam a agenda'>
        Um dia cadastrado aqui não gera vagas na agenda da empresa. Feriados marcados como "repete
        todo ano" valem para o mesmo dia nos anos seguintes, sem precisar recadastrar.
        {!podeEscrever &&
          ' Seu perfil consulta os feriados; o cadastro é feito pelo administrador da instituição.'}
      </InfoAlert>

      <TableCard>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            <h3 className='card-label fw-bold text-gray-800'>Feriados</h3>
          </div>
          {podeEscrever && (
            <div className='card-toolbar'>
              <Button className='btn btn-primary' icon={IconPaths.Add} onClick={abrirCadastro}>
                Novo feriado
              </Button>
            </div>
          )}
        </div>
        <FeriadosTable />
      </TableCard>
    </>
  )
}

export const FeriadosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <FeriadosList />
    </QueryResponseProvider>
  </QueryRequestProvider>
)
